// extracted by mini-css-extract-plugin
export default {"weekContainer":"CalendarWeek_weekContainer__w7+HH","day":"CalendarWeek_day__X-cMb","text":"CalendarWeek_text__fIpTL"};